<div class="dialog-content">
  <app-window-title subtitle="View files shared with this user"
                    [closable]="true"
                    [title]="'Files shared with ' + data.userName"
                    (closed)="dialogRef.close()">
  </app-window-title>

  <!-- File Info Section -->
  <div class="file-info-section">
    <div class="file-info-card">
      <div class="file-icon-wrapper">
        <mat-icon class="file-icon">
          folder_shared
        </mat-icon>
        <div class="file-type-badge">
          Files
        </div>
      </div>
      <div class="file-details">
        <p class="file-message">
          Files shared with
          <strong class="file-name-highlight">
            {{data.userName}}
          </strong>
        </p>
        <div class="shared-stats">
          <span class="shared-count">
            <mat-icon class="stat-icon">
              folder
            </mat-icon>
            {{ data.files?.length || 0 }} {{ (data.files?.length || 0) === 1 ? 'file' : 'files' }}
          </span>
          <span class="user-email">
            <mat-icon class="stat-icon">
              email
            </mat-icon>
            {{data.userEmail}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Files List -->
  <div *ngIf="data.files && data.files.length > 0"
       class="files-list">
    <div class="list-header">
      <h3 class="list-title">
        Shared Files
      </h3>
      <div class="list-actions">
        <button class="action-button"
                color="primary"
                mat-button
                [disabled]="refreshing"
                (click)="onRefreshData()">
          <mat-icon>
            refresh
          </mat-icon>
          Refresh
        </button>
      </div>
    </div>

    <div class="files-grid">
      <div *ngFor="let file of data.files; trackBy: trackByFile"
           class="file-item">
        <div class="file-icon-container">
          <div class="file-icon-wrapper">
            <mat-icon [class]="getFileIcon(file.fileType)">
              {{getFileIcon(file.fileType)}}
            </mat-icon>
            <div class="file-type-indicator"
                 [class]="getFileTypeClass(file.fileType)"></div>
          </div>
        </div>

        <div class="file-info">
          <div class="file-name">
            {{file.fileName || 'Unknown File'}}
          </div>
          <div class="file-details">
            <span *ngIf="file.fileSize"
                  class="file-size">
              <mat-icon class="detail-icon">
                storage
              </mat-icon>
              {{getFileSize(file.fileSize)}}
            </span>
            <span *ngIf="file.uploadDate"
                  class="file-date">
              <mat-icon class="detail-icon">
                schedule
              </mat-icon>
              {{file.uploadDate | date:'short'}}
            </span>
            <span *ngIf="file.sharedDate"
                  class="file-shared-date">
              <mat-icon class="detail-icon">
                share
              </mat-icon>
              Shared {{file.sharedDate | date:'short'}}
            </span>
          </div>
        </div>

        <div class="file-actions">
          <button class="view-button"
                  color="primary"
                  mat-icon-button
                  matTooltip="View file">
            <mat-icon>
              visibility
            </mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- No Files State -->
  <div *ngIf="!data.files || data.files.length === 0"
       class="empty-state">
    <div class="empty-content">
      <mat-icon class="empty-icon">
        folder_open
      </mat-icon>
      <h3 class="empty-title">
        No Shared Files
      </h3>
      <p class="empty-description">
        No files are currently shared with {{data.userName}}.
      </p>
      <button class="empty-action"
              color="primary"
              mat-raised-button
              (click)="onClose()">
        <mat-icon>
          folder
        </mat-icon>
        Browse Files
      </button>
    </div>
  </div>
</div>
